//封装ajax请求
import { message } from "antd"
export default function ajax(url, data = {}, method = "get") {
    return new Promise(async (resolve, reject) => {
        //如果值为空就移除
        for (const key in data) {
            if (data[key]===undefined) {
                delete data[key]
            }
        }

        var promise;
        if (method.toLowerCase() === "post") { //如果是POST请求
            promise = fetch(url, {
                method: method,
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(res => res.json())

        } else if (method.toLowerCase() === "get") { //如果是GET请求
            let queryStr = [];
            if (Object.keys(data).length !== 0) {
                for (const key in data) {
                    queryStr.push(key + "=" + data[key])
                }
            }
            queryStr = queryStr.join("&")
            promise = fetch(url + "?" + queryStr).then(res => res.json())
        }

        try {
            const response = await promise
            resolve(response)
        } catch (error) {
            message.error("请求错误" + error.message)
        }

    })

}